import { get } from 'framework/api/http';
import { useQuery } from 'react-query';

/* Get user dashboard video list */
export const getEnterpriseDashboardTop10Videos = async ({ queryKey }: any) => {
  const { id } = queryKey[1];
  const res = await get(`/external-api/get_enterprise_top10_videos/${id}`);
  return res?.data || [];
};

/* Use Query as a Hook */
export const useGetEnterpriseDashboardTop10Videos = (
  queryParams: any,
  onSuccess: any,
  onError: any,
) => {
  return useQuery(['ent-dashboard-top-videos', queryParams], getEnterpriseDashboardTop10Videos, {
    refetchOnWindowFocus: false,
    enabled: false,
    retry: 0,
    onSuccess,
    onError,
  });
};

export default useGetEnterpriseDashboardTop10Videos;
